"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MD_EXPORT_CONTEXT = void 0;
exports.DEFAULT_MD_EXPORT_CONTEXT = {
    withMedia: false,
    withStyle: false,
};
